// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run pnpm gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MyDepositAddressUpdatedSubscriptionVariables = Types.Exact<{
  walletCurrency?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type MyDepositAddressUpdatedSubscription = { __typename?: 'Subscription', bankingMyDepositAdded?: { __typename?: 'BankingMyDepositAddedSubscriptionPayload', clientSubscriptionId?: string, banking?: { __typename?: 'Banking', id: string, myCurrentAddress?: { __typename?: 'BankingAddress', id: string, address?: string, createTime?: number } } } };


export const MyDepositAddressUpdatedSubscriptionDocument = /*#__PURE__*/ gql`
    subscription MyDepositAddressUpdatedSubscription($walletCurrency: String) {
  bankingMyDepositAdded(input: {}) {
    banking {
      id
      myCurrentAddress(currency: $walletCurrency) {
        id
        address
        createTime
      }
    }
    clientSubscriptionId
  }
}
    `;
export function useMyDepositAddressUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<MyDepositAddressUpdatedSubscription, MyDepositAddressUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<MyDepositAddressUpdatedSubscription, MyDepositAddressUpdatedSubscriptionVariables>(MyDepositAddressUpdatedSubscriptionDocument, options);
      }
export type MyDepositAddressUpdatedSubscriptionHookResult = ReturnType<typeof useMyDepositAddressUpdatedSubscription>;
export type MyDepositAddressUpdatedSubscriptionSubscriptionResult = Apollo.SubscriptionResult<MyDepositAddressUpdatedSubscription>;